import styled from 'styled-components';

import { mediaBreakpoint } from '../../utils/mediaBreakpoint';

const DescList = styled.dl`
    ${mediaBreakpoint.up('md')} {
        display: grid;
        grid-template-columns: repeat(2, auto);
        column-gap:${({ theme }) => theme.Spacing.spacing1x};
        max-width: 475px;
    }
`;

export default DescList;
